import { getCookieValue } from '@naturehouse/nh-essentials/lib/cookies/cookie';

type Experiments = Record<string, number>;

const EXPERIMENTS_COOKIE = 'nh_experiments';
const FIRST_VARIANT = 1;

export default class ExperimentsService {
    static #instance: ExperimentsService | null = null;

    public static getInstance(): ExperimentsService {
        if (this.#instance === null) {
            this.#instance = new ExperimentsService();
        }

        return this.#instance;
    }

    public static destroyInstance(): void {
        this.#instance = null;
    }

    private constructor() {
        if (ExperimentsService.#instance) {
            throw new Error('Use getInstance() to access ExperimentsService.');
        }
    }

    public isActive(experimentName: string, expectedVariant: number = FIRST_VARIANT): boolean {
        const experiments = this.#getExperiments();
        return experiments[experimentName] === expectedVariant;
    }

    #getExperiments(): Experiments {
        const cookieValue = getCookieValue(EXPERIMENTS_COOKIE);

        if (!cookieValue) {
            return {};
        }

        try {
            const decodedValue = decodeURIComponent(cookieValue);
            const experiments = JSON.parse(decodedValue) as unknown;

            if (!this.#isExperiments(experiments)) {
                return {};
            }

            return experiments;
        } catch {
            return {};
        }
    }

    #isExperiments(value: unknown): value is Experiments {
        if (typeof value !== 'object' || value === null) {
            return false;
        }

        return Object.values(value).every((entry) => typeof entry === 'number');
    }
}
